// Image URL resolution.
//
// Historically we stored absolute URLs that baked in the request host at upload
// time (e.g. `https://member-hub-120.preview.emergentagent.com/api/uploads/<id>`).
// That broke on production because the baked host was preview-only.
//
// New rule: upload endpoints return RELATIVE paths like `/api/uploads/<id>`;
// callers use `resolveImageUrl` at render time to prepend the current backend
// base, so every environment resolves to its own correct origin.
const API_BASE = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/+$/, '');
// Legacy prefix we silently strip — the path after it is already the right one.
const LEGACY_PREVIEW_PREFIX_RE = /^https?:\/\/[^/]*\.(preview\.emergentagent\.com|emergent\.host)/i;

/**
 * Turn whatever is stored in the DB into a browser-usable URL for the current
 * environment.
 *
 *   • empty / null       → ''                        (consumer should hide the img)
 *   • `/api/uploads/<id>`→ `${API_BASE}/api/uploads/<id>`
 *   • `https://cdn...`   → kept as-is (external image hotlinks)
 *   • legacy baked host  → stripped, re-prefixed with API_BASE
 *   • data:/blob:        → kept as-is (freshly previewed uploads)
 */
export function resolveImageUrl(raw) {
    if (!raw) return '';
    const s = String(raw).trim();
    if (!s) return '';
    if (s.startsWith('data:') || s.startsWith('blob:')) return s;
    if (s.startsWith('/')) return `${API_BASE}${s}`;
    const match = s.match(LEGACY_PREVIEW_PREFIX_RE);
    if (match) {
        const rest = s.slice(match[0].length);
        return `${API_BASE}${rest.startsWith('/') ? rest : `/${rest}`}`;
    }
    return s; // external URL, respect it
}
